import PlurallClient from '@plurall/client'

const graphqlClient = () => {
  const client = new PlurallClient({
    apiURL: process.env.REACT_APP_PLURALL_API_URL,
    graphqlURL: process.env.REACT_APP_SOMOS_GRAPHQL_URL,
    applicationId: process.env.REACT_APP_ID_APPLICATION,
    useTokenValidation: false,
  })

  return client.graphqlClient
}

const graphQLMutate = async (mutation, options) => {
  const { data, error } = await graphqlClient().mutate({
    mutation,
    ...options,
  })

  return { data, error }
}

const graphQLQuery = async (query, options) => {
  const { data, error } = await graphqlClient().query({
    query,
    ...options,
  })

  return { data, error }
}

const handleGraphQLErrors = graphQLErrors => {
  if (graphQLErrors) {
    return graphQLErrors.map(error => error.message)
  }
  return []
}

export { graphQLMutate, graphQLQuery, handleGraphQLErrors }
